module.exports = __webpack_public_path__ + "static/img/img-home-co-24.8fff2e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-24.png
// module id = mtGQ
// module chunks = 1